export const COMMON_TDK = {
  Title: "",
  Keywords:
    "微观世界, 房产软件, 房产直播地图, 房源系统, 全景制作, 看房小程序, 直播挂载小程序, 微信获客小程序, 房地产行业, 营销软件, 客户管理",
  Description:
    "微观世界，专注于为房地产行业提供创新软件解决方案。我们的产品包括房产直播地图、智能房源系统、全景制作服务、看房小程序、直播挂载小程序及微信获客小程序，助力房企高效营销与客户管理",
};
